import React from 'react';
import { QuoteIcon } from 'lucide-react';
interface Testimonial {
  id: number;
  content: string;
  author: string;
  role: string;
  company: string;
  avatar: string;
}
interface TestimonialsSectionProps {
  testimonials: Testimonial[];
}
export const TestimonialsSection = ({
  testimonials
}: TestimonialsSectionProps) => {
  return <section className="py-20 bg-[#0F1115]" data-id="element-145">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-146">
        <div className="max-w-3xl mx-auto text-center mb-16" data-id="element-147">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 leading-tight" data-id="element-148">
            Trusted by{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-[#d73b3e] to-orange-500" data-id="element-149">
              industry leaders
            </span>
          </h2>
          <p className="text-lg text-gray-400" data-id="element-150">
            See what companies and developers are saying about us
          </p>
        </div>
        <div className="grid md:grid-cols-3 gap-8" data-id="element-151">
          {testimonials.map(testimonial => <div key={testimonial.id} className="bg-[#1a1d24] p-8 rounded-2xl shadow-lg border border-gray-800 relative" data-id="element-152">
              <QuoteIcon className="absolute top-8 right-8 w-8 h-8 text-gray-700 opacity-50" data-id="element-153" />
              <p className="text-gray-300 mb-6 leading-relaxed relative z-10" data-id="element-154">
                "{testimonial.content}"
              </p>
              <div className="flex items-center gap-4" data-id="element-155">
                <img src={testimonial.avatar} alt={testimonial.author} className="w-12 h-12 rounded-full object-cover border-2 border-gray-700" data-id="element-156" />
                <div data-id="element-157">
                  <div className="font-semibold text-white" data-id="element-158">
                    {testimonial.author}
                  </div>
                  <div className="text-sm text-gray-500" data-id="element-159">
                    {testimonial.role}, {testimonial.company}
                  </div>
                </div>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
};